import React from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import UnassignJobForm from './form'

function UnassignJobDialog ({ open, onClose, job }) {
  return (
    <SydModal
      open={open}
      onClose={onClose}
      title='Unassign Job from Target'
      size='medium'
    >
      {open ? (
        <UnassignJobForm job={job} onCancel={onClose} />
      ) : null}
    </SydModal>
  )
}

UnassignJobDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  job: PropTypes.object
}

export default UnassignJobDialog
